module.exports = __webpack_public_path__ + "static/media/discussion-icon-grey.6e530ac3.svg";